import gsap from 'gsap';
import CustomEase from 'gsap/dist/CustomEase';
import ObjectsHolder from '../ObjectsHolder';
import { radians } from '../../../../utils/degreesAndRadians';
import { findChildren } from '../../../../utils/objects3D';

gsap.registerPlugin(CustomEase);

const THREE = require('three');

const pushWingsUnitToArray = (arr, right, left) => {
    if (right) arr.push({ target: right, sign: 1, coord: 'z' });
    if (left) arr.push({ target: left, sign: -1, coord: 'z' });
};

class AnimatedButterflyWingsObject3D extends ObjectsHolder {
    constructor(data, webgl, obj3D, reflection3D = null) {
        super(data, webgl, {
            obj3D, reflection3D
        });
    }

    _setup(data, stgs, webgl) {
        super._setup(data, stgs, webgl);

        this.hasInvalidate = true;
        this.hasTweens = true;
    }

    _constructView(data, webgl, stgs, factory, orientation) {
        super._constructView(data, webgl, stgs, factory, orientation);

        const { obj3D, reflection3D } = stgs;

        this.add(obj3D);

        this.obj3D = obj3D;

        let reflectionShell = null;

        if (reflection3D) {
            reflectionShell = new THREE.Group();
            reflectionShell.add(reflection3D);
        }

        // You need to inject reflectionShell instead of reflection3D. i.e. you need to substitute it
        this.reflection3D = reflection3D;
        this.reflectionShell = reflectionShell;

        const rightTopWing = findChildren(obj3D, 'wing_right_top', true);
        const leftTopWing = findChildren(obj3D, 'wing_left_top', true);
        const rightBackWing = findChildren(obj3D, 'wing_right_back', true);
        const leftBackWing = findChildren(obj3D, 'wing_left_back', true);

        const rightTopWingSync = findChildren(reflection3D, 'wing_right_top', true);
        const leftTopWingSync = findChildren(reflection3D, 'wing_left_top', true);
        const rightBackWingSync = findChildren(reflection3D, 'wing_right_back', true);
        const leftBackWingSync = findChildren(reflection3D, 'wing_left_back', true);

        this.topWings = [];
        pushWingsUnitToArray(this.topWings, rightTopWing, leftTopWing);
        pushWingsUnitToArray(this.topWings, rightTopWingSync, leftTopWingSync);

        this.backWings = [];
        pushWingsUnitToArray(this.backWings, rightBackWing, leftBackWing);
        pushWingsUnitToArray(this.backWings, rightBackWingSync, leftBackWingSync);

        this.state = {
            rotation: 0,
            rotationX: 0,
            rotationY: 0,
            rotationChanged: true
        };
    }

    _start() {
        const ease0 = CustomEase.create(
            'custom',
            'M0,0 C0.036,0 0.008,0.289 0.17,0.474 0.349,0.678 0.632,0.749 0.738,0.862 0.848,0.98 0.956,1 1,1 '
        );
        const tl = gsap.timeline({
            repeat: -1
        });

        const onUpdate = () => {
            this.state.rotationChanged = true;
        };

        tl.to(this.state, {
            duration: 0.5,
            rotation: -35,
            rotationX: 1,
            rotationY: 10,
            ease: ease0,
            onUpdate
        });

        tl.to(this.state, {
            duration: 2,
            rotation: 0,
            rotationX: 0,
            rotationY: 0,
            onUpdate
        });

        tl.to(this.state, {
            duration: 3,
            rotation: -35,
            rotationX: 1,
            rotationY: 10,
            ease: ease0,
            onUpdate
        });
        tl.to(this.state, {
            duration: 0.75,
            rotation: -35,
            rotationX: 1,
            rotationY: 10,
            ease: ease0,
            onUpdate
        });

        tl.to(this.state, {
            duration: 1.5,
            rotation: 0,
            rotationX: 0,
            rotationY: 0,
            onUpdate
        });

        tl.to(this.state, {
            duration: 4,
            rotationX: 4,
            onUpdate
        });

        tl.to(this.state, {
            duration: 2,
            rotation: 0,
            rotationX: 0,
            rotationY: 0,
            onUpdate
        });
    }

    invalidate(t, dt) {
        super.invalidate(t, dt);

        if (this.state.rotationChanged) {
            const { rotation, rotationX, rotationY } = this.state;

            this.topWings.forEach((obj) => {
                obj.target.rotation.z = obj.sign * radians(rotation);
                obj.target.rotation.x = radians(rotationX);
                obj.target.rotation.y = obj.sign * radians(rotationY);
            });

            this.backWings.forEach((obj) => {
                obj.target.rotation.z = obj.sign * radians(rotation * 0.7);
                obj.target.rotation.x = radians(rotationX);
                obj.target.rotation.y = obj.sign * radians(rotationY);
            });
        }

        this.state.rotationChanged = false;
    }
}

export default AnimatedButterflyWingsObject3D;
